import React from 'react';
import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';
import { containers, Grid } from 'style';

const QuoteComponent = ({
  quote,
  author,
  highlightColor,
  authorColor,
  backgroundColor,
  textColor,
}) => (
    <Grid.Wrapper
      backgroundColor={backgroundColor && backgroundColor.hex}
      textColor={textColor && textColor.hex}
      id="QuoteComponent">
        <div className="wrapper">
          <div className="container-fluid">
        
          <QuoteContainer>
            <SlideOnVisible percent={30}>
              <QuoteMarkdown
                source={quote}
                plugins={[breaks]}
                renderers={{ paragraph: 'span' }}
                highlightColor={
                  highlightColor && highlightColor.hex
                }
                className="text1"
              />
              <Author color={authorColor && authorColor.hex}>{author}</Author>
            </SlideOnVisible>
          </QuoteContainer>
      </div>
      </div>
    </Grid.Wrapper>
  );

const SlideOnVisible = styled(OnVisible)`
    transition: all 0s;
    transform: translateY(40px);
    opacity: 0.01;

    &.visible {
        transition: all 0.5s;
        transform: translateY(0px);
        opacity: 1;
    }
`;

const QuoteMarkdown = styled(ReactMarkdown)`

    strong {
        color: inherit;
        transition: all 0.5s 0.5s;
        font-weight: normal;
    }
    .visible & strong {
        color: ${props => props.highlightColor};
    }
    margin-bottom: 30px;
`;

const Author = styled.h4`
    color: ${props => props.color};

    transition: all 0s;
    transform: translateY(40px);
    opacity: 0.01;

    .visible & {
        transition: all 0.5s 0.3s;
        transform: translateY(0px);
        opacity: 1;
    }
`;
const QuoteContainer = styled(Grid.Col)`
    @media (min-width: ${containers.small}px) {
      width: 66.66vw;
    }

    margin: 0 auto;

    .ViewsNews & {
        @media (min-width: ${containers.innerPX}px) {
            margin: 0 0 0 170px;
        }
    }
`;

export default QuoteComponent;
